import React, { useEffect, useState } from 'react'
import styles from './style/icon_button_style.module.scss';
import PropTypes from 'prop-types';
import Icon, { IconMap } from '../../foundations/icon/Icon'
import HarveyIcon from '../harvey-icon/HarveyIcon'

const IconButton = ({ children, onClick, className = '', disabled, ...props }) => {
    const [buttonClasses, setButtonClasses] = useState('')
    const [isOver, setIsOver] = useState(false)

    const IconImage = props.hImg ?
            <HarveyIcon harveyImg={props.img} dentImg={props.hImg} face={isOver ? 'dent' : 'harvey'} {...props} size="100%"/>
            :
            <Icon img={props.img} size="100%"/>

    useEffect(() => {
        const _styles = []
        Object.keys(props).forEach(key => {
            if (ICON_BUTTON_PROPTYPES[key]) {
                _styles.push(styles[key])
            }
        })
        setButtonClasses(_styles.join(' '))
    }, []);

    const switchIcon = over => {
        if (over && props.hImg) setIsOver(true)
        else if (props.img) setIsOver(false)
    }

    return (
        <div className={`${styles.button} ${buttonClasses} ${className} ${disabled ? styles.disabled : ''}`}
             onMouseEnter={() => switchIcon(true)}
             onMouseLeave={() => switchIcon(false)}
             onClick={disabled ? undefined : onClick}
        >
            {IconImage}
        </div>
    )
}

const ICON_BUTTON_PROPTYPES = {
    'size-s': PropTypes.bool,
    'size-m': PropTypes.bool,
    'size-l': PropTypes.bool,
    'style-primary': PropTypes.bool,
    'style-inverse': PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    img:  PropTypes.oneOf(Object.keys(IconMap)).isRequired,
    hImg:  PropTypes.oneOf(Object.keys(IconMap)),
};

IconButton.propTypes = ICON_BUTTON_PROPTYPES


export default IconButton;
